<template>
	<div>
		<layout-1
		:table_name="'Files'"
		:id=pageid
		:searchbar=false
		:navbar=false
		:button_perm="'67'"
		:button_name="'Download'"
		:term=term
		v-on:select="select"
		style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
		<div class="nav-bar">
			<button v-on:click="addFile()">Add File</button>
			<button v-on:click="deleteFile()">Delete File</button>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.FILES_PAGE,
		}
	},
	methods:{
		addFile(){
			router.push('/0405?q='+this.term);
		},
		select(value){
			api.getFileDownload(
				{
					type:"search",
					data:{
						pageid:this.pageid,
						fileid:value[0],
					}
				}
			).then((res) => {
				if(res.data!=null){
					var fileURL = window.URL.createObjectURL(new Blob([res.data]));
					var fileLink = document.createElement('a');

					fileLink.href = fileURL;
					fileLink.setAttribute('download', value[3]);
					document.body.appendChild(fileLink);

					fileLink.click();
				}
			});

		},
		deleteFile(){
			router.push('/0505?q='+this.term);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Job_Orders_Files.vue